import { render, staticRenderFns } from "./LayoutSide.vue?vue&type=template&id=367650ed"
import script from "./LayoutSide.vue?vue&type=script&lang=js"
export * from "./LayoutSide.vue?vue&type=script&lang=js"
import style0 from "./LayoutSide.vue?vue&type=style&index=0&id=367650ed&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports